// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/pipeline.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * Event-triggered automation pipeline
 * Replaces Automation + Flow engine
 *
 * @generated from message omnios.v1.Pipeline
 */
export const Pipeline = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Pipeline",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trigger_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "trigger_filter", kind: "message", T: Struct },
    { no: 7, name: "steps", kind: "message", T: PipelineStep, repeated: true },
    { no: 8, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "executor_agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PipelineStep
 */
export const PipelineStep = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineStep",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "operation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "args", kind: "message", T: Struct },
    { no: 4, name: "inputs", kind: "message", T: StepBinding, repeated: true },
    { no: 5, name: "condition", kind: "message", T: StepBinding },
  ],
);

/**
 * @generated from message omnios.v1.StepBinding
 */
export const StepBinding = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StepBinding",
  () => [
    { no: 1, name: "param_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_step_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 3, name: "from_entrypoint", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 4, name: "literal_json", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 5, name: "output_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Result of a single pipeline step execution
 *
 * @generated from message omnios.v1.PipelineStepResult
 */
export const PipelineStepResult = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineStepResult",
  () => [
    { no: 1, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PipelineStepResult_Status) },
    { no: 3, name: "outputs", kind: "message", T: Struct },
    { no: 4, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "duration_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum omnios.v1.PipelineStepResult.Status
 */
export const PipelineStepResult_Status = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.PipelineStepResult.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED"},
    {no: 1, name: "RUNNING"},
    {no: 2, name: "COMPLETED"},
    {no: 3, name: "FAILED"},
    {no: 4, name: "SKIPPED"},
    {no: 5, name: "DISABLED"},
  ],
);

/**
 * Full execution record
 *
 * @generated from message omnios.v1.PipelineRun
 */
export const PipelineRun = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineRun",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pipeline_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "executor_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "step_results", kind: "message", T: PipelineStepResult, repeated: true },
    { no: 6, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "stopped_at_step", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "started_at", kind: "message", T: Timestamp },
    { no: 9, name: "completed_at", kind: "message", T: Timestamp },
    { no: 10, name: "progress_pct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "progress_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "entrypoint_data", kind: "message", T: Struct },
    { no: 13, name: "pipeline_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "produced_entities", kind: "message", T: PipelineRunEntity, repeated: true },
  ],
);

/**
 * Structured log entry emitted during pipeline execution
 *
 * @generated from message omnios.v1.PipelineRunLog
 */
export const PipelineRunLog = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineRunLog",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "enum", T: proto3.getEnumType(PipelineRunLog_Level) },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum omnios.v1.PipelineRunLog.Level
 */
export const PipelineRunLog_Level = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.PipelineRunLog.Level",
  [
    {no: 0, name: "INFO"},
    {no: 1, name: "WARN"},
    {no: 2, name: "ERROR"},
    {no: 3, name: "DEBUG"},
  ],
);

/**
 * Entity produced or touched by a pipeline run
 *
 * @generated from message omnios.v1.PipelineRunEntity
 */
export const PipelineRunEntity = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PipelineRunEntity",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "entity_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreatePipelineRequest
 */
export const CreatePipelineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePipelineRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "trigger_filter", kind: "message", T: Struct },
    { no: 5, name: "steps", kind: "message", T: PipelineStep, repeated: true },
    { no: 6, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "executor_agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPipelineRequest
 */
export const GetPipelineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPipelineRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePipelineRequest
 */
export const UpdatePipelineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePipelineRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "trigger_event", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "trigger_filter", kind: "message", T: Struct },
    { no: 6, name: "steps", kind: "message", T: PipelineStep, repeated: true },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "executor_agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListPipelinesRequest
 */
export const ListPipelinesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPipelinesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListPipelinesResponse
 */
export const ListPipelinesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPipelinesResponse",
  () => [
    { no: 1, name: "pipelines", kind: "message", T: Pipeline, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ExecutePipelineRequest
 */
export const ExecutePipelineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExecutePipelineRequest",
  () => [
    { no: 1, name: "pipeline_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entrypoint_data", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListPipelineRunsRequest
 */
export const ListPipelineRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPipelineRunsRequest",
  () => [
    { no: 1, name: "pipeline_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListPipelineRunsResponse
 */
export const ListPipelineRunsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPipelineRunsResponse",
  () => [
    { no: 1, name: "runs", kind: "message", T: PipelineRun, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * Workspace-wide run listing (for the tasks page)
 *
 * @generated from message omnios.v1.ListAllRunsRequest
 */
export const ListAllRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllRunsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "only_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelPipelineRunRequest
 */
export const CancelPipelineRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelPipelineRunRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelPipelineRunResponse
 */
export const CancelPipelineRunResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelPipelineRunResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetRunLogsRequest
 */
export const GetRunLogsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetRunLogsRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetRunLogsResponse
 */
export const GetRunLogsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetRunLogsResponse",
  () => [
    { no: 1, name: "logs", kind: "message", T: PipelineRunLog, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListRunEntitiesRequest
 */
export const ListRunEntitiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRunEntitiesRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListRunEntitiesResponse
 */
export const ListRunEntitiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRunEntitiesResponse",
  () => [
    { no: 1, name: "entities", kind: "message", T: PipelineRunEntity, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityRunsRequest
 */
export const ListEntityRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityRunsRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityRunsResponse
 */
export const ListEntityRunsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityRunsResponse",
  () => [
    { no: 1, name: "runs", kind: "message", T: PipelineRun, repeated: true },
  ],
);

